import { getOldUIRoutes } from '../../../routes'

const style = { width: '100%', height: '100%', border: 0 }

export const PlayersSettings: React.FC = () => {
  //NOTE: Route to playersView is fetched here, not as prefethed const
  //      Otherwise problems with session_key not updating properly
  return <iframe title='Players settings' src={getOldUIRoutes.playersView()} style={style} />
}
